import Input from "components/Input";
import styled from "styled-components";

export const CustomIcon = styled.img`
  margin-right: 5px;
  margin-bottom: - 2px;
  filter: brightness(0) invert(1);
`;

export const Checkbox = styled(Input)`
  &[type="checkbox"]:disabled:before {
    background-color: #bebebe;
    border: 2px solid #a0a0a0;
  }
`;